import { render, staticRenderFns } from "./AnalyticsController.vue?vue&type=template&id=10513ad6&"
import script from "./AnalyticsController.vue?vue&type=script&lang=js&"
export * from "./AnalyticsController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports